'use client';

/**
 * Initializes the browser PostHog client once on mount for the entire
 * landing app. Without this, every visitor gets `posthog === undefined`,
 * which means:
 *   - `useExperimentVariant` (e.g. landing-hero-headline) can't read
 *     feature-flag assignments and falls back to control for everyone
 *   - autocapture / pageview / session-recording events never fire
 *   - identify() called on later sign-up doesn't get a session-replay
 *     stitch
 *
 * Safe to call when `NEXT_PUBLIC_POSTHOG_KEY` is unset — `initBrowserPostHog`
 * bails silently in that case.
 */
import { useEffect } from 'react';
import { captureFirstTouchAttribution, initBrowserPostHog } from '@plura/shared/track';

export function PostHogBootstrap() {
  useEffect(() => {
    void initBrowserPostHog();
    // Persist first-touch attribution (utm / referrer / landing page) in a
    // cross-subdomain cookie so it can be stamped onto the User row when the
    // visitor later signs up on app.formsuite.co.
    captureFirstTouchAttribution();
  }, []);
  return null;
}
